import type React from "react";

// React replays events from portaled children (e.g. an open dialog) through the component tree.
export const isOwnDomEvent = (event: React.SyntheticEvent) =>
  event.target instanceof Node && event.currentTarget.contains(event.target);
